export default {
  get: {
    method: 'post',
    url: '/journey-schedule'
  },
  getLocations: {
    method: 'get',
    url: '/journey-schedule/locations'
  },
  confirm: {
    method: 'post',
    url: '/journey-schedule/confirm/ID'
  },
  manual: {
    method: 'post',
    url: '/journey-schedule/manual'
  },
  setting: {
    get: {
      method: 'get',
      url: '/journey-schedule/setting'
    },
    update: {
      method: 'post',
      url: '/journey-schedule/setting'
    },
    reset: {
      method: 'post',
      url: '/journey/reset'
    }
  }
}
